import ReactDOM from "react-dom";
import App from "./App";
import { SidebarContextProvider } from "./store/sidebarContext";
import { LangContextProvider } from "./store/langContext";
import { ThemeContextProvider } from "./store/themeContext";
import { LoginContextProvider } from "./store/loginContext";
import { getRuntimeConfig, loadRuntimeConfig, RuntimeConfig } from "./config/RuntimeConfig";
import baseURL from "./services/axiosInstance";
export let imgeURL:any;
export let imgeThumbnailURL:any;

async function bootstrap() {
  try {
    // Load runtime config first
    await loadRuntimeConfig();
    const runtimeConfig = getRuntimeConfig();
    // Ensure axios uses correct API baseURL
    baseURL.defaults.baseURL = runtimeConfig.REACT_APP_API_BASE_URL;


    const config: RuntimeConfig = getRuntimeConfig();

    // Set exported URLs
    imgeURL = config.REACT_APP_IMAGE_URL;
    imgeThumbnailURL = config.REACT_APP_IMAGE_THUMBNAIL_URL;

ReactDOM.render(
  <LangContextProvider>
    <LoginContextProvider>
      <ThemeContextProvider>
        <SidebarContextProvider>
          <App />
        </SidebarContextProvider>
      </ThemeContextProvider>
    </LoginContextProvider>
  </LangContextProvider>,
  document.getElementById("root")
);

 } catch (error) {
    console.error(":x: Failed to load runtime config", error);
    ReactDOM.render(
      <div style={{ padding: 20, color: "red" }}>
        <h1>Failed to load configuration</h1>
        <p>Please try refreshing the page.</p>
      </div>,
       document.getElementById("root")
    );
  }
}
bootstrap();